import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './PremiumPanel.module.css';
import { LandingDiscountChip } from '@features/landing/shared/ui/components/LandingDiscountChip';

type Props = {
  title: ReactNode;
  amount: ReactNode;
  description?: ReactNode;
  advances?: ReactNode[];
  action: ReactNode;
  discount?: ReactNode;
  studentDiscount?: {
    oldAmount: ReactNode;
    chip: ReactNode;
  };
  size?: 'small' | 'medium';
  className?: string;
};

export function PremiumPanel({
  title,
  discount,
  amount,
  description,
  advances,
  action,
  studentDiscount,
  size = 'medium',
  className,
}: Props) {
  return (
    <div className={cx(styles.root, styles[`size_${size}`], className)}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>

        {discount && (
          <div className={styles.discount}>
            <LandingDiscountChip>{discount}</LandingDiscountChip>
          </div>
        )}
      </div>

      <div className={styles.content}>
        {studentDiscount && (
          <div className={styles.studentDiscount}>
            <span className={styles.oldAmount}>
              {studentDiscount.oldAmount}
            </span>
            <LandingDiscountChip>{studentDiscount.chip}</LandingDiscountChip>
          </div>
        )}
        <div
          className={cx(styles.amount, {
            [styles.discounted]: Boolean(studentDiscount),
          })}
        >
          {amount}
        </div>
        {description && <div className={styles.description}>{description}</div>}
        {advances && (
          <ul className={styles.advancesList}>
            {advances.map((a, idx) => (
              <li key={idx} className={styles.advancesItem}>
                <div>{a}</div>
              </li>
            ))}
          </ul>
        )}
        <div className={styles.action}>{action}</div>
      </div>
    </div>
  );
}
